import { permissions } from "./Permissions";

const loginInitialValues = {
  email: "",
  password: "",
};
const signUpInitialValues = {
  name: "",
  email: "",
  phoneCode: "+966",
  phoneNumber: "",
  password: "",
  hasAgreedTnC: false,
  selectedPlan: "NONE",
};

const resetPasswordValues = {
  email: "",
};

const verifyCodeValues = {
  otp: "",
};

const newPasswordValues = {
  newPassword: "",
  confirmPassword: "",
};
const orgnisationDetailsInitialValues = {
  companyName: "",
  commercialNumber: "",
  countryId: "",
  vatNumber: "",
};

// MEETING ROOMS
const createMeetingRoomValues = {
  spaceTypeInt: 2,
  spaceType: "meetingRoom",
  imageUrls: [],
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
  branchId: null,
  cityId: null,
  price: "",
  numberOfSeats: "",
  amenities: [],
  customPrice: [
    { days: null, startTime: "12:30 AM", endTime: "01:30 AM", price: "" },
  ],
};

const createWorkspaceValues = {
  spaceTypeInt: 1,
  spaceType: "workSpace",
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
  imageUrls: [],
  cityId: null,
  branchId: null,
  amenities: [],
  status: 1, // 0: Deactive, 1: Active, 2: Delete, 3: Draft
  timePeriods: [
    {
      name: "",
      nameAr: "",
      numberOfSeats: 1,
      price: null,
      discount: null,
      time: { start: "12:30 AM", end: "01:30 AM" },
    },
  ],
};

const createWorkshopValues = {
  spaceTypeInt: 3,
  spaceType: "workShop",
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
  topics: "",
  topicsAr: "",
  imageUrls: [],
  cityId: "",
  branchId: "",
  childSpaceId: "",
  amenities: [],
  status: 1,
  dateAndTimes: {
    moreDays: false,
    numberOfDays: 2,
    duration: 2,
    selectedDates: [
      // {
      //   startTime: {
      //     date: "",
      //     start: "",
      //     end: "",
      //   },
    ],
  },
  workShopDetails: {
    trainerShare: null,
    companyShare: null,
    tax: null,
    trainerName: "",
    ageGroup: {
      min: null,
      max: null,
    },
    numberOfSeats: null,
    price: null,
    discount: null,
    gender: null,
  },
  shareScheduleDate: "",
  bankInfo: {
    accountHolder: "",
    bankName: "",
    IBAN: "",
  },
  customerInfo: {
    name: "",
    phoneCode: "",
    phoneNumber: "",
    socialMediaAccount: "",
  },
  workshopType: Number(1),
};

const addBranchValues = {
  name: "",
  nameAr: "",
  address: "",
  addressAr: "",
  cityId: "",
  latitude: null,
  longitude: null,
  imageUrls: [],
  status: 1,
  mapLocation: "",
  wifiNetworkName: "",
  wifiNetworkPassword: "",
  lockMac: "",
};

const addUserValues = {
  name: "",
  email: "",
  accountType: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  role: "",
  branches: [],
};

const addRoleValues = {
  name: "",
  nameAr: "",
  permissions: permissions,
};

const createCashbackValues = {
  id: "", // Required by your API
  title: "", // English title
  titleAr: "", // Arabic title
  promoText: [
    // Array of promotional texts
    {
      description: "", // English promo text
      descriptionAr: "", // Arabic promo text
    },
  ],
  cycleExpiredIn: "", // Default to 1 month (as string for form handling)
  levels: [
    // Array of cashback levels
    {
      title: "", // English level name
      titleAr: "", // Arabic level name
      value: "", // Number of bookings
      cashbackPercentage: "", // Percentage value
      expiredIn: "", // Expiration in months
    },
    {
      title: "",
      titleAr: "",
      value: "",
      cashbackPercentage: "",
      expiredIn: "",
    },
  ],
};
const createOfficeValues = {
  spaceTypeInt: 4,
  spaceType: "office",
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
  imageUrls: [],
  cityId: null,
  branchId: null,
  officeArea: null,
  amenities: [],
  status: 1, // 0: Deactive, 1: Active, 2: Delete, 3: Draft
  monthlyPlans: [
    {
      name: "",
      nameAr: "",
      duration: 1,
      price: 0,
      discountPrice: 0,
      offerId: null,
      features: [{ title: "", titleAr: "" }],
    },
  ],
  yearlyPlans: [
    {
      name: "",
      nameAr: "",
      duration: 1,
      price: 0,
      discountPrice: 0,
      offerId: null,
      features: [{ title: "", titleAr: "" }],
    },
  ],
  isMonthlyEnabled: false,
  isYearlyEnabled: false,
};
const createHotDeskValues = {
  spaceTypeInt: 5,
  spaceType: "hotDesk",
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
  imageUrls: [],
  cityId: null,
  branchId: null,
  amenities: [],
  status: 1, // 0: Deactive, 1: Active, 2: Delete, 3: Draft
  oneDayPass: {
    name: "",
    nameAr: "",
    price: 0,
  },
  monthlyPlans: [
    {
      name: "",
      nameAr: "",
      duration: 1,
      price: 0,
      discountPrice: 0,
      offerId: null,
      features: [{ title: "", titleAr: "" }],
    },
  ],
  yearlyPlans: [
    {
      name: "",
      nameAr: "",
      duration: 1,
      price: 0,
      discountPrice: 0,
      offerId: null,
      features: [{ title: "", titleAr: "" }],
    },
  ],
  isDayEnabled: false,
  isMonthlyEnabled: false,
  isYearlyEnabled: false,
  totalSeats: null,
};


export {
  signUpInitialValues,
  loginInitialValues,
  orgnisationDetailsInitialValues,
  resetPasswordValues,
  verifyCodeValues,
  newPasswordValues,
  createMeetingRoomValues,
  createWorkspaceValues,
  createWorkshopValues,
  addBranchValues,
  addUserValues,
  addRoleValues,
  createCashbackValues,
  createOfficeValues,
  createHotDeskValues
};
